export = {
    _extensions: {},
};
